import { defineMessages } from 'react-intl';

const taxTypeDetails = defineMessages({
  vat: {
    id: 'hosting.tax_details_page_.vat_details',
    defaultMessage: 'VAT details'
  },
  gst: {
    id: 'hosting.tax_details_page_.gst_details',
    defaultMessage: 'GST details'
  },
  hst: {
    id: 'hosting.tax_details_page_.hst_details',
    defaultMessage: 'HST details'
  },
  gstHst: {
    id: 'hosting.tax_details_page_.gst_hst_details',
    defaultMessage: 'GST/HST details'
  },
  allProvinces: {
    id: 'hosting.tax_details_page_.all_provincial_tax_details',
    defaultMessage: 'QST/PST/RST details'
  },
  pst: {
    id: 'hosting.tax_details_page_.pst_details',
    defaultMessage: 'PST details'
  },
  rst: {
    id: 'hosting.tax_details_page_.rst_details',
    defaultMessage: 'RST details'
  },
  qst: {
    id: 'hosting.tax_details_page_.qst_details',
    defaultMessage: 'QST details'
  },
  salesTax: {
    id: 'hosting.tax_details_page_.sales_tax_details',
    defaultMessage: 'Sales tax details'
  }
});

export const intlTaxTypeDetails = {
  VAT: taxTypeDetails.vat,
  GST: taxTypeDetails.gst,
  HST: taxTypeDetails.hst,
  gst_hst: taxTypeDetails.gstHst,
  all_provinces: taxTypeDetails.allProvinces,
  PST: taxTypeDetails.pst,
  RST: taxTypeDetails.rst,
  QST: taxTypeDetails.qst,
  other: taxTypeDetails.salesTax
}

const taxTypeRates = defineMessages({
  vat: {
    id: 'hosting.tax_details_page_.vat_percentage',
    defaultMessage: 'VAT %'
  },
  gst: {
    id: 'hosting.tax_details_page_.gst_percentage',
    defaultMessage: 'GST %'
  },
  gstHst: {
    id: 'hosting.tax_details_page_.gst_hst_percentage',
    defaultMessage: 'GST/HST %'
  },
  tax: {
    id: 'hosting.tax_details_page_.tax_percentage',
    defaultMessage: 'Tax %'
  },
  allProvinces: {
    id: 'hosting.tax_details_page_.all_provinces_percentage',
    defaultMessage: 'QST/PST/RST %'
  }
});

export const intlTaxTypeRates = {
  VAT: taxTypeRates.vat,
  GST: taxTypeRates.gst,
  gst_hst: taxTypeRates.gstHst,
  all_provinces: taxTypeRates.allProvinces,
  other: taxTypeRates.tax
}

const taxTypeId = defineMessages({
  vat: {
    id: 'hosting.tax_details_page_.vat_id',
    defaultMessage: 'VAT ID'
  },
  gst: {
    id: 'hosting.tax_details_page_.gst_id',
    defaultMessage: 'GST ID'
  },
  rst: {
    id: 'hosting.tax_details_page_.rst_id',
    defaultMessage: 'RST ID'
  },
  pst: {
    id: 'hosting.tax_details_page_.pst_id',
    defaultMessage: 'PST ID'
  },
  qst: {
    id: 'hosting.tax_details_page_.qst_id',
    defaultMessage: 'QST ID'
  },
  gstHst: {
    id: 'hosting.tax_details_page_.gst_hst_id',
    defaultMessage: 'GST/HST ID'
  },
  id: {
    id: 'hosting.tax_details_page_.id',
    defaultMessage: 'ID'
  },
  allProvinces: {
    id: 'hosting.tax_details_page_.all_provinces_id',
    defaultMessage: 'QST/PST/RST ID'
  }
});

export const intlTaxTypeId = {
  VAT: taxTypeId.vat,
  GST: taxTypeId.gst,
  RST: taxTypeId.rst,
  PST: taxTypeId.pst,
  QST: taxTypeId.qst,
  gst_hst: taxTypeId.gstHst,
  other: taxTypeId.id,
  all_provinces: taxTypeId.allProvinces
}

const taxTypeRegistrationDetails = defineMessages({
  vat: {
    id: 'hosting.tax_details_page_.vat_registration',
    defaultMessage: 'VAT registration details'
  },
  gstHst: {
    id: 'hosting.tax_details_page_.gst_hst_registration',
    defaultMessage: 'GST/HST registration details'
  },
  gst: {
    id: 'hosting.tax_details_page_.gst_registration',
    defaultMessage: 'GST registration'
  },
  registration: {
    id: 'hosting.tax_details_page_.registration',
    defaultMessage: 'Registration details'
  }
});

export const intlTaxTypeRegistrationDetails = {
  VAT: taxTypeRegistrationDetails.vat,
  GST: taxTypeRegistrationDetails.gst,
  gst_hst: taxTypeRegistrationDetails.gstHst,
  other: taxTypeRegistrationDetails.registration,
  all_provinces: taxTypeRegistrationDetails.registration
}

const taxTypeAddDetails = defineMessages({
  vat: {
    id: 'hosting.tax_details_page_.vat_add_details',
    defaultMessage: 'Add VAT details'
  },
  gst: {
    id: 'hosting.tax_details_page_.gst_add_details',
    defaultMessage: 'Add GST details'
  },
  gstHst: {
    id: 'hosting.tax_details_page_.gst_hst_add_details',
    defaultMessage: 'Add GST/HST details'
  },
  allProvinces: {
    id: 'hosting.tax_details_page_.all_provinces_add_details',
    defaultMessage: 'QST/PST/RST details'
  }
});

export const intlTaxTypeAddDetails = {
  VAT: taxTypeAddDetails.vat,
  GST: taxTypeAddDetails.gst,
  gst_hst: taxTypeAddDetails.gstHst,
  all_provinces: taxTypeAddDetails.allProvinces,
  other: taxTypeAddDetails.vat
}


const taxTypeUpdateDetails = defineMessages({
  vat: {
    id: 'hosting.tax_details_page_.vat_update_details',
    defaultMessage: 'Update VAT details'
  },
  gst: {
    id: 'hosting.tax_details_page_.gst_update_details',
    defaultMessage: 'Update GST details'
  },
  gstHst: {
    id: 'hosting.tax_details_page_.gst_hst_update_details',
    defaultMessage: 'Update GST/HST details'
  },
  allProvinces: {
    id: 'hosting.tax_details_page_.all_provinces_update_details',
    defaultMessage: 'Update QST/PST/RST details'
  }
});

export const intlTaxTypeUpdateDetails = {
  VAT: taxTypeUpdateDetails.vat,
  GST: taxTypeUpdateDetails.gst,
  gst_hst: taxTypeUpdateDetails.gstHst,
  all_provinces: taxTypeUpdateDetails.allProvinces,
  other: taxTypeUpdateDetails.vat
}

const taxTypeRegisteredAddress = defineMessages({
  vat: {
    id: 'hosting.tax_details_page_.vat_registered_address',
    defaultMessage: 'VAT registered address'
  },
  gst: {
    id: 'hosting.tax_details_page_.gst_registered_address',
    defaultMessage: 'GST registered address'
  },
  gstHst: {
    id: 'hosting.tax_details_page_.gst_hst_registered_address',
    defaultMessage: 'GST/HST registered address'
  },
  allProvinces: {
    id: 'hosting.tax_details_page_.all_provinces_registered_address',
    defaultMessage: 'Registered address for provincial taxes'
  }
});

export const intlTaxTypeRegisteredAddress = {
  VAT: taxTypeRegisteredAddress.vat,
  GST: taxTypeRegisteredAddress.gst,
  gst_hst: taxTypeRegisteredAddress.gstHst,
  all_provinces: taxTypeRegisteredAddress.allProvinces,
  other: taxTypeRegisteredAddress.vat
}

const taxTypeBusinessCopy = defineMessages({
  vat: {
    id: 'hosting.tax_details_page_.vat_business_name_copy',
    defaultMessage: 'Business name as it appears on your VAT registration.'
  },
  gst: {
    id: 'hosting.tax_details_page_.gst_business_name_copy',
    defaultMessage: 'Business name as it appears on your GST registration.'
  },
  gstHst: {
    id: 'hosting.tax_details_page_.gst_hst_business_name_copy',
    defaultMessage: 'Business name as it appears on your GST/HST registration.'
  },
  allProvinces: {
    id: 'hosting.tax_details_page_.all_provinces_business_name_copy',
    defaultMessage: 'Business name as it appears on your provincial tax registration.'
  }
});

export const intlTaxTypeBusinessCopy = {
  VAT: taxTypeBusinessCopy.vat,
  GST: taxTypeBusinessCopy.gst,
  gst_hst: taxTypeBusinessCopy.gstHst,
  all_provinces: taxTypeBusinessCopy.allProvinces,
  other: taxTypeBusinessCopy.vat
}

// Remove Taxes Modal translations
const removeTaxTypeHeader = defineMessages({
  vat: {
    id: 'hosting.remove_taxes.remove_VAT_details',
    defaultMessage: 'Remove VAT details'
  },
  gst: {
    id: 'hosting.remove_taxes.remove_GST_details',
    defaultMessage: 'Remove GST details'
  },
  gstHst: {
    id: 'hosting.remove_taxes.remove_GST_HST_details',
    defaultMessage: 'Remove GST/HST details'
  },
  allProvinces: {
    id: 'hosting.remove_taxes.remove_tax_details',
    defaultMessage: 'Remove tax details'
  }
});

export const intlRemoveTaxTypeHeader = {
  VAT: removeTaxTypeHeader.vat,
  GST: removeTaxTypeHeader.gst,
  gst_hst: removeTaxTypeHeader.gstHst,
  all_provinces: removeTaxTypeHeader.allProvinces,
  other: removeTaxTypeHeader.vat
}

const removeTaxCopy = defineMessages({
  vat: {
    id: 'hosting.remove_taxes.remove_VAT_copy',
    defaultMessage: 'Are you sure you want to remove your VAT details?'
  },
  gst: {
    id: 'hosting.remove_taxes.remove_GST_copy',
    defaultMessage: 'Are you sure you want to remove your GST details?'
  },
  gstHst: {
    id: 'hosting.remove_taxes.remove_GST_HST_copy',
    defaultMessage: 'Are you sure you want to remove your GST/HST details?'
  },
  allProvinces: {
    id: 'hosting.remove_taxes.remove_tax_copy',
    defaultMessage: 'Are you sure you want to remove your tax details?'
  }
});

export const intlRemoveTaxCopy = {
  VAT: removeTaxCopy.vat,
  GST: removeTaxCopy.gst,
  gst_hst: removeTaxCopy.gstHst,
  all_provinces: removeTaxCopy.allProvinces,
  other: removeTaxCopy.vat
}

const removeTax = defineMessages({
  vat: {
    id: 'hosting.remove_taxes.remove_VAT',
    defaultMessage: 'Remove VAT'
  },
  gst: {
    id: 'hosting.remove_taxes.remove_GST',
    defaultMessage: 'Remove GST'
  },
  gstHst: {
    id: 'hosting.remove_taxes.remove_GST_HST',
    defaultMessage: 'Remove GST/HST'
  },
  allProvinces: {
    id: 'hosting.remove_taxes.remove_tax',
    defaultMessage: 'Remove tax'
  }
});

export const intlRemoveTax = {
  VAT: removeTax.vat,
  GST: removeTax.gst,
  gst_hst: removeTax.gstHst,
  all_provinces: removeTax.allProvinces,
  other: removeTax.vat
}

const vatRegisteredModalHeader = defineMessages({
  vat: {
    id: 'hosting.vat_registered_modal.vat_registered',
    defaultMessage: 'Are you registered for VAT?'
  },
  gst: {
    id: 'hosting.vat_registered_modal.gst_registered',
    defaultMessage: 'Are you registered for GST?'
  },
  hst: {
    id: 'hosting.vat_registered_modal.hst_registered',
    defaultMessage: 'Are you registered for HST?'
  },
  gstHst: {
    id: 'hosting.vat_registered_modal.gst_hst_registered',
    defaultMessage: 'Are you registered for GST/HST?'
  }
});

export const intlVatRegisteredModalHeader = {
  VAT: vatRegisteredModalHeader.vat,
  GST: vatRegisteredModalHeader.gst,
  HST: vatRegisteredModalHeader.hst,
  gst_hst: vatRegisteredModalHeader.gstHst
}
// new
const taxTypes = defineMessages({
  vat: {
    id: 'hosting.tax_details_page_.vat',
    defaultMessage: 'VAT'
  },
  qst: {
    id: 'hosting.tax_details_page_.qst',
    defaultMessage: 'QST'
  },
  pst: {
    id: 'hosting.tax_details_page_.pst',
    defaultMessage: 'PST'
  },
  rst: {
    id: 'hosting.tax_details_page_.rst',
    defaultMessage: 'RST'
  },
  gst: {
    id: 'hosting.tax_details_page_.gst',
    defaultMessage: 'GST'
  },
  hst: {
    id: 'hosting.tax_details_page_.hst',
    defaultMessage: 'HST'
  },
  gstHst: {
    id: 'hosting.tax_details_page_.gst_hst',
    defaultMessage: 'GST/HST'
  }
});

export const intlTaxTypes = {
  VAT: taxTypes.vat,
  QST: taxTypes.qst,
  PST: taxTypes.pst,
  RST: taxTypes.rst,
  GST: taxTypes.gst,
  HST: taxTypes.hst,
  gst_hst: taxTypes.gstHst
}

const taxInvoicesType = defineMessages({
  vat: {
    id: 'hosting.invoice_page.vat_invoices',
    defaultMessage: 'VAT invoices'
  },
  qst: {
    id: 'hosting.invoice_page.qst_invoices',
    defaultMessage: 'QST invoices'
  },
  pst: {
    id: 'hosting.invoice_page.pst_invoices',
    defaultMessage: 'PST invoices'
  },
  rst: {
    id: 'hosting.invoice_page.rst_invoices',
    defaultMessage: 'RST invoices'
  },
  gst: {
    id: 'hosting.invoice_page.gst_invoices',
    defaultMessage: 'GST invoices'
  },
  hst: {
    id: 'hosting.invoice_page.hst_invoices',
    defaultMessage: 'HST invoices'
  },
  gstHst: {
    id: 'hosting.invoice_page.gst_hst_invoices',
    defaultMessage: 'GST/HST invoices'
  },
  tax: {
    id: 'hosting.invoice_page.tax_invoices',
    defaultMessage: 'Tax invoices'
  }
});

export const intlTaxInvoicesType = {
  VAT: taxInvoicesType.vat,
  QST: taxInvoicesType.qst,
  PST: taxInvoicesType.pst,
  RST: taxInvoicesType.rst,
  GST: taxInvoicesType.gst,
  HST: taxInvoicesType.hst,
  gst_hst: taxInvoicesType.gstHst,
  tax: taxInvoicesType.tax,
}

const taxTypeCharged = defineMessages({
  vat: {
    id: 'hosting.invoice_page.vat_charged',
    defaultMessage: 'VAT charged'
  },
  qst: {
    id: 'hosting.invoice_page.qst_charged',
    defaultMessage: 'QST charged'
  },
  pst: {
    id: 'hosting.invoice_page.pst_charged',
    defaultMessage: 'PST charged'
  },
  rst: {
    id: 'hosting.invoice_page.rst_charged',
    defaultMessage: 'RST charged'
  },
  gst: {
    id: 'hosting.invoice_page.gst_charged',
    defaultMessage: 'GST charged'
  },
  hst: {
    id: 'hosting.invoice_page.hst_charged',
    defaultMessage: 'HST charged'
  },
  gstHst: {
    id: 'hosting.invoice_page.gst_hst_charged',
    defaultMessage: 'GST/HST charged'
  },
  tax: {
    id: 'hosting.invoice_page.tax_charged',
    defaultMessage: 'Tax charged'
  }
});

export const intlTaxTypeCharged = {
  VAT: taxTypeCharged.vat,
  QST: taxTypeCharged.qst,
  PST: taxTypeCharged.pst,
  RST: taxTypeCharged.rst,
  GST: taxTypeCharged.gst,
  HST: taxTypeCharged.hst,
  gst_hst: taxTypeCharged.gstHst,
  tax: taxTypeCharged.tax,
}

const txnType = defineMessages({
  charge: {
    id: 'hosting.invoice_page.charge_for_booking_text',
    defaultMessage: 'Charge for booking'
  },
  refund: {
    id: 'hosting.invoice_page.refund_for_booking_text',
    defaultMessage: 'Refund for booking'
  }
});

export const intlTxnType = {
  CHARGE: txnType.charge,
  REFUND: txnType.refund
}

const addOnsTaxType = defineMessages({
  vat: {
    id: 'hosting.tax_details_page.vat_paid_add_ons_copy',
    defaultMessage: 'If you have paid add-ons, please confirm which ones need VAT % added'
  },
  gst: {
    id: 'hosting.tax_details_page.gst_paid_add_ons_copy',
    defaultMessage: 'If you have paid add-ons, please confirm which ones need GST % added'
  },
  qst: {
    id: 'hosting.tax_details_page.qst_paid_add_ons_copy',
    defaultMessage: 'If you have paid add-ons, please confirm which ones need QST % added'
  },
  pst: {
    id: 'hosting.tax_details_page.pst_paid_add_ons_copy',
    defaultMessage: 'If you have paid add-ons, please confirm which ones need PST % added'
  },
  rst: {
    id: 'hosting.tax_details_page.rst_paid_add_ons_copy',
    defaultMessage: 'If you have paid add-ons, please confirm which ones need RST % added'
  },
  gstHst: {
    id: 'hosting.tax_details_page.gst_hst_paid_add_ons_copy',
    defaultMessage: 'If you have paid add-ons, please confirm which ones need GST/HST % added'
  },
  hst: {
    id: 'hosting.tax_details_page.hst_paid_add_ons_copy',
    defaultMessage: 'If you have paid add-ons, please confirm which ones need HST % added'
  },
  tax: {
    id: 'hosting.tax_details_page.tax_paid_add_ons_copy',
    defaultMessage: 'If you have paid add-ons, please confirm which ones need tax % added'
  }
});

export const intlAddOnsTaxType = {
  VAT: addOnsTaxType.vat,
  QST: addOnsTaxType.qst,
  PST: addOnsTaxType.pst,
  RST: addOnsTaxType.rst,
  GST: addOnsTaxType.gst,
  HST: addOnsTaxType.hst,
  gst_hst: addOnsTaxType.gstHst,
  tax: addOnsTaxType.tax,
  other: addOnsTaxType.tax
}
